import { Field, InputType, Int } from '@nestjs/graphql'

@InputType()
export class CategoryReorderInput {
  @Field(t => Int)
  id!: number

  @Field(t => Int, { nullable: true })
  parentCategoryId?: number | null

  @Field(t => Int)
  sortOrder!: number
}
